import { IAdserverCreative, transformAdserverCreativeWrapper } from '~/src/dash/api/console-api';
import {
  parseArray,
  parseNumber,
  parseString,
  transformModel,
} from '~/src/dash/api/resource-transforms';
import {
  addDomainAndTokenToUrl,
  IHttpResponse,
  restDelete,
  restGet,
  restPatch,
  restPost,
} from '~/src/dash/api/rest';

export interface IAdserverGlobalVast {
  ID: number;
  CreatedAt?: string;
  UpdatedAt: string;
  DeletedAt?: string;

  PublisherID: number;
  URL: string;
  Name: string;
  AdserverCreatives: IAdserverCreative[];
  CampaignIDS: number[];
  AdvertiserID: number;
}

export interface ICreateGlobalVastResponse {
  AdserverCreative: IAdserverCreative;
  AdserverGlobalVast: IAdserverGlobalVast;
}

export const marshalAdserverGlobalVast = transformModel<IAdserverGlobalVast>({
  ID: parseNumber(['ID']),

  PublisherID: parseNumber(['PublisherID']),
  URL: parseString(['URL']),
  Name: parseString(['Name']),
  AdserverCreatives: parseArray(['AdserverCreatives'], transformAdserverCreativeWrapper),
  CampaignIDS: parseArray(['CampaignIDS'], (obj: any) => {
    return obj;
  }),
  AdvertiserID: parseNumber(['AdvertiserID']),
});

export async function getGlobalVasts(
  publisherID: string,
): Promise<IHttpResponse<IAdserverGlobalVast[]>> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/${publisherID}/global_vasts`);
  return await restGet<IAdserverGlobalVast[]>(reqUrl, {});
}

export async function createGlobalVast(
  globalVast: IAdserverGlobalVast,
  publisherID: string,
  creativeID?: string,
): Promise<IHttpResponse<ICreateGlobalVastResponse>> {
  const reqUrl =
    addDomainAndTokenToUrl(`/publishers/${publisherID}/global_vasts`) +
    `&creative_id=${creativeID ? creativeID : ''}`;
  const parsedGlobalVast = marshalAdserverGlobalVast(globalVast);
  return await restPost<ICreateGlobalVastResponse>(reqUrl, parsedGlobalVast);
}

// NOTE: Because a full object is required, make sure that all fields in the object are defined in the interface/transform
export async function updateGlobalVast(
  globalVast: any,
  publisherID: string,
): Promise<IHttpResponse<IAdserverGlobalVast>> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/${publisherID}/global_vasts/${globalVast.ID}`);
  const parsedGlobalVast = marshalAdserverGlobalVast(globalVast);
  return await restPatch<IAdserverGlobalVast>(reqUrl, parsedGlobalVast);
}

export async function deleteGlobalVast(
  globalVastID: string,
  publisherID: string,
): Promise<IHttpResponse<IAdserverGlobalVast>> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/${publisherID}/global_vasts/${globalVastID}`);
  return await restDelete<IAdserverGlobalVast>(reqUrl, undefined);
}

export async function addGlobalVastToLineItems(
  campaignIDs: string,
  globalVastID: string,
  publisherID: string,
): Promise<IHttpResponse<IAdserverGlobalVast[]>> {
  const reqUrl =
    addDomainAndTokenToUrl(`/publishers/${publisherID}/add_global_vast_to_line_items`) +
    `&campaign_ids=${campaignIDs}&global_vast_id=${globalVastID}`;
  return await restPost(reqUrl, {});
}
